module.exports = __webpack_public_path__ + "img/gemlogo.9612602e.png";